import PropTypes from 'prop-types';
import { useLocation, useSearchParams } from 'react-router-dom';
import {
  Select,
  Checkbox,
  MenuItem,
  Collapse,
  FormControl,
  ListItemText,
  OutlinedInput,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const SelectColumnFilter = ({
  cell,
  options,
  multiple = false,
  isValueRequired = false,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    isShowFilter,
    column: { id, filterValue, setFilter },
    resetPage,
  } = cell;

  const location = useLocation();

  const handleChange = e => {
    if (isValueRequired && (!e.target.value || !e.target.value?.length)) {
      return;
    }
    const value = e.target.value || [];
    resetPage();
    setFilter(value);
    searchParams.set([id], value);
    setSearchParams(searchParams, { ...location, replace: true });
  };

  const selectValue = !multiple
    ? options?.length && filterValue
      ? filterValue
      : ''
    : options?.length && filterValue
    ? typeof filterValue === 'string'
      ? filterValue.split(',')
      : filterValue
    : [];

  return (
    <Collapse id={id} in={isShowFilter} timeout="auto">
      <FormControl fullWidth variant="standard">
        <Select
          id={'Select-' + id}
          name={id}
          value={selectValue}
          input={<OutlinedInput />}
          IconComponent={KeyboardArrowDownIcon}
          MenuProps={{
            autoFocus: false,
          }}
          onChange={handleChange}
          multiple={multiple}
          renderValue={selected => {
            if (Array.isArray(selected)) {
              return selected.join(', ');
            } else {
              return selected;
            }
          }}
        >
          {options.map(el => (
            <MenuItem key={el} value={el} title={el}>
              {multiple && (
                <Checkbox
                  checked={selectValue.indexOf(el) > -1}
                  className="column-filter-checkbox"
                />
              )}
              <ListItemText primary={el} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Collapse>
  );
};

SelectColumnFilter.propTypes = {
  cell: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  multiple: PropTypes.bool,
  isValueRequired: PropTypes.bool,
};

export default SelectColumnFilter;
